import styled from "styled-components";

const getColor = (color) => {
    switch (color) {
        case 'success':
            return 'var(--color-success)';
        case 'error':
            return 'var(--color-error)';
        case 'warning':
            return 'var(--color-warning)';
        default:
            return 'var(--theme-color-primary)';
    }
};

export const CardPrimary = styled.div`
  width: -webkit-fill-available;
  max-width: ${props => props.size === 'small' ? '244px' : props.size === 'large' ? '300px' : '100%'};
  /* width: ${props => props.size === 'small' ? '220px' : props.size === 'large' ? '300px' : '250px'}; */
  height: ${props => props.size === 'small' ? '70px' : props.size === 'large' ? '200px' : '100px'};
  background-color: ${props => getColor(props.customColor ? props.customColor : 'default')};
  display: flex;
  flex-direction: column;
  align-items: ${props => props.size === 'small' ? 'flex-start' : 'center'};
  justify-content: center;
  gap: 10px;

  padding: ${props => props.size === 'small' ? '16px' : props.size === 'large' ? '40px 10px' : '24px 10px'};
  border-radius: 1rem;
  text-align: center;
  text-transform: capitalize;
  overflow: hidden;

 h2 {
    margin: 0;
    color: ${props => props.color ? props.color : 'var(--theme-color-white)'};
    font-weight: 600;
    letter-spacing: -0.02em;
    font-size: 24px;
    /* line-height: 1; */
  }

  h3 {
    color: ${props => props.color ? props.color : 'var(--theme-color-white)'};
    /* font-weight: 400; */
    margin: 0;
    font-size: 14px;
    line-height: 1;
    text-transform: none;
  }

  /* Mobile responsiveness */
  @media (max-width: 768px) {
    max-width: 100%;
    width: 100%;
    height: ${props => props.size === 'small' ? '60px' : props.size === 'large' ? '150px' : '80px'};
    padding: ${props => props.size === 'small' ? '10px' : props.size === 'large' ? '24px 8px' : '16px 8px'};
    border-radius: 0.75rem;

    h2 {
      font-size: 18px;
    }

    h3 {
      font-size: 12px;
    }
  }

  /* Small mobile devices */
  @media (max-width: 480px) {
    height: ${props => props.size === 'small' ? '55px' : props.size === 'large' ? '130px' : '70px'};
    padding: ${props => props.size === 'small' ? '8px' : props.size === 'large' ? '20px 6px' : '14px 6px'};

    h2 {
      font-size: 16px;
    }

    h3 {
      font-size: 11px;
    }
  }
`;